import useMainStore from '@/stores/main';
import {getCookie} from '@/utils/main';
import {useEffect} from 'react';

export const useResizeWidth = () => {
  const {
    checkAd,
    isShowMainBanner,
    isCloseMainBanner,
    setIsShowMainBanner,
    setResizeCount,
    setResizeMainLiveCount,
    setResizeCategoryCount,
  } = useMainStore();

  const updateWidth = (container) => {
    if (!container) return;
    setResizeCount(getResizeCount(container));
    setResizeCategoryCount(getResizeCategoryCount(container));
    setResizeMainLiveCount(getResizeMainLiveCount(container));
  };

  useEffect(() => {
    const container = document.getElementById('container');
    if (!container) return;
    const handleResize = () => updateWidth(container);

    const observer = new ResizeObserver(handleResize);
    observer.observe(container);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!checkAd.banners.hasOwnProperty('bAdPcMainBanner')) return;
    const count = getCookie('lastMainBannerViewCount');
    const handleResize = () => {
      if (
        checkAd.banners.bAdPcMainBanner &&
        checkAd.banners.bAdPcMainBannerCount >= count
      ) {
        const width = window.innerWidth; //스크롤바 영역때문에 window.innerWidth 기준으로 취득
        if (width <= 1200) {
          setIsShowMainBanner(false);
        } else {
          if (!isCloseMainBanner) {
            setIsShowMainBanner(true);
          }
        }
      }
    };
    const wrap = document.getElementById('soop_wrap');
    const observer = new ResizeObserver(handleResize);
    if (wrap) {
      observer.observe(wrap);
    }
    return () => {
      observer && observer.disconnect();
    };
  }, [isShowMainBanner, window.innerWidth]);
};

function getResizeCount(container) {
  if (container) {
    const width = container.clientWidth;
    let count = 1;
    if (width >= 1687) {
      count = 6;
    } else if (width >= 1261 && width < 1687) {
      count = 5;
    } else if (width >= 1060 && width < 1260) {
      count = 4;
    } else if (width >= 810 && width < 1060) {
      count = 3;
    } else if (width >= 556 && width < 810) {
      count = 2;
    } else {
      count = 1;
    }

    return count;
  }
}

function getResizeMainLiveCount(container) {
  if (container) {
    const computedStyle = window.getComputedStyle(container);
    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
    const contentWidth = container.clientWidth - (paddingLeft + paddingRight);

    let count = 1;
    if (contentWidth >= 1623) {
      count = 6;
    } else if (contentWidth >= 1202 && contentWidth < 1623) {
      count = 5;
    } else if (contentWidth >= 1000 && contentWidth < 1202) {
      count = 4;
    } else if (contentWidth >= 751 && contentWidth < 1000) {
      count = 3;
    } else if (contentWidth >= 496 && contentWidth < 751) {
      count = 2;
    } else {
      count = 1;
    }

    return count;
  }
}

function getResizeCategoryCount(container) {
  if (container) {
    const computedStyle = window.getComputedStyle(container);
    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
    const contentWidth = container.clientWidth - (paddingLeft + paddingRight);

    let count = 1;
    if (contentWidth >= 1623) {
      count = 10;
    } else if (contentWidth >= 1202 && contentWidth < 1623) {
      count = 8;
    } else if (contentWidth >= 1000 && contentWidth < 1202) {
      count = 6;
    } else if (contentWidth >= 751 && contentWidth < 1000) {
      count = 5;
    } else if (contentWidth >= 496 && contentWidth < 751) {
      count = 4;
    } else {
      count = 3;
    }

    return count;
  }
}
